export interface ComparisonRow {
  sin: string;
  con: string;
}

export const comparisonRows: ComparisonRow[] = [{
  sin: '3–5 hs/semana planificando desde cero.',
  con: '10 min/semana. El resto es entrenar.'
}, {
  sin: 'Siempre los mismos ejercicios.',
  con: '+60 sesiones distintas listas para usar.'
}, {
  sin: 'Jugadoras que abandonan sin saber por qué.',
  con: 'Progresión y seguimiento para mejorar la retención.'
}, {
  sin: 'Sin estructura clara de semana a semana.',
  con: '7 tomos con temporada completa resuelta.'
}, {
  sin: 'Lesión en el plantel = pánico.',
  con: 'Protocolo anti-lesiones listo para activar.'
}, {
  sin: 'Niveles mezclados = caos en el entrenamiento.',
  con: 'Variaciones por nivel en cada ejercicio.'
}, {
  sin: 'Sin imagen profesional visible.',
  con: 'Sistema que ayuda a justificar un servicio más profesional.'
}, {
  sin: 'Sin trabajo específico para cada jugadora.',
  con: 'Desarrollo individual y progresión personalizada.'
}];
